import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductsPage from "../pages/products/page";
import ProductDetailPage from "../pages/products/detail/page";
import RequestQuotePage from "../pages/request-quote/page";
import ServicesPage from "../pages/services/page";
import IndustriesPage from "../pages/industries/page";
import AboutPage from "../pages/about/page";
import SupportPage from "../pages/support/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/products/:slug",
    element: <ProductDetailPage />,
  },
  {
    path: "/request-quote",
    element: <RequestQuotePage />,
  },
  { path: "/services", element: <ServicesPage /> },
  { path: "/industries", element: <IndustriesPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/support", element: <SupportPage /> },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;